var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('v-card',[_c('v-card-title',[_vm._v("Datos del Usuario")]),_c('v-card-text',[_vm._v("Nombre: "+_vm._s(_vm.user.name))])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }